import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import Print, { type PrintHandle } from "@components/print/print";
import { flushSync } from "react-dom";

export interface PrintTrtagHandle {
  print: (pdfUrls: string[]) => Promise<void>;
}

const PrintTrtag = forwardRef<PrintTrtagHandle, {}>((_, ref) => {
  const printRef = useRef<PrintHandle>(null);
  const [pdfUrls, setPdfUrls] = useState<string[]>([]);

  useImperativeHandle(ref, () => ({
    print: async (urls: string[]) => {
      flushSync(() => {
        setPdfUrls(urls);
      });
      await printRef.current?.print();
      setPdfUrls([]);
    },
  }));

  return (
    <Print ref={printRef}>
      {/* 110 * 90 */}
      <Print.Pdf pdfUrls={pdfUrls} width={110} height={undefined} />
    </Print>
  );
});

export default React.memo(PrintTrtag);
